import React, { useState, useEffect } from 'react';
import { BsSun, BsMoon } from 'react-icons/bs';
import './ThemeToggle.scss';

const ThemeToggle = () => {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved === 'dark';
  });
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);

  useEffect(() => {
    const hasSeenToast = localStorage.getItem('darkModeToastSeen');
    if (!hasSeenToast) {
      const timer = setTimeout(() => {
        setShowToast(true);
        localStorage.setItem('darkModeToastSeen', 'true');
        setTimeout(() => setShowToast(false), 4000);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <>
      {showToast && (
        <div className="app__theme-toast">
          <BsMoon /> Dark mode is available!
        </div>
      )}
      <div className="app__theme-toggle" onClick={() => setDarkMode(!darkMode)}>
        {darkMode ? <BsSun /> : <BsMoon />}
      </div>
    </>
  );
};

export default ThemeToggle;
